import { paths } from '../../config';
import MainContainer from '../main-container';
import List from './commissionList';

const settings = {
    pathList: paths.commission,
    apiPath: 'comission',
    permissionAdmin: null,
    title: 'Comissões',
    entity: 'invoiceDetail',
};

const CommissionList: React.FC = () => {
    return (
        <MainContainer>
            <List settings={settings} />
        </MainContainer>
    );
};

export { CommissionList };
